import { Box, BoxProps, styled } from '@mui/material';

export const CustomChip = styled(Box)<BoxProps & { size: 'sm' | 'md', enabledPadding?: boolean }>(({ size, enabledPadding = true }) => ({
  padding: enabledPadding ? '2px 10px' : '2px 0px',
  borderRadius: '16px',
  fontWeight: 500,
  fontSize: size === 'sm' ? '12px' : '14px',
  lineHeight: size === 'sm' ? '18px' : '20px',
}));
